<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">版本号：</div>
          <el-input v-model="page.versionNo" class="ipt-sty" placeholder="请输入版本号"></el-input
        ></el-col>
        <el-col :span="8">
          <div class="search-area-div">上架状态：</div>
          <el-select v-model="page.bizState" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in bizStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">应用端：</div>
          <el-select v-model="page.appSideGuid" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in appSideGuidList" :key="item.guid" :label="item.appSideName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="search">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addVersion">发布版本</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="应用端" header-align="center" align="center">
          <template slot-scope="scope">{{ getAppSideName(scope.row.appSideGuid) }}</template>
        </el-table-column>

        <el-table-column
          prop="campaignsState"
          show-overflow-tooltip
          label="版本号"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{ scope.row.versionNo }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="说明" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.versionDesc }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="上架状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.bizState == 'Y' ? '已上架' : '已下架' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateDate | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row.guid)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">应用端 </span>
          <el-select v-model="appSideGuid" placeholder="请选择应用端" class="fl">
            <el-option
              v-for="item in appSideGuidList"
              :key="item.guid"
              :label="item.appSideName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">版本号 </span>
          <el-input
            type="textarea"
            :rows="5"
            :maxlength="100"
            placeholder="规则：迭代版本+日期+次数+F/B(前端/后端)"
            v-model="versionNo"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">说明 </span>
          <el-input type="textarea" :rows="5" :maxlength="200" placeholder="请输入发布的内容" v-model="versionDesc">
          </el-input>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">上架状态 </span>
          <el-radio-group v-model="bizState" style="margin-left: -350px">
            <el-radio label="Y">上架</el-radio>
            <el-radio label="N">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '发布版本'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '发布版本',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizState: '',
        versionNo: '',
        appSideGuid: '',
      },
      appSideGuid: '',
      versionNo: '',
      versionDesc: '',
      bizState: 'Y',
      articleId: '',
      tableLoading: false,
      appSideGuidList: [],
      bizStateList: [
        {
          label: '上架',
          value: 'Y',
        },
        {
          label: '下架',
          value: 'N',
        },
      ],
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,
    };
  },
  created() {
    this.getAppSideGuidList();
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msConfigureService}/version/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizState: '',
        versionNo: '',
        appSideGuid: '',
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '发布版本';
      this.versionNo = '';
      this.versionDesc = '';
      this.appSideGuid = '';
      this.dialogVisible = true;
    },
    editVersion(guid) {
      this.textTitle = '修改版本';
      this.versionNo = '';
      this.versionDesc = '';
      this.appSideGuid = '';
      this.dialogVisible = true;
      var self = this;
      self.api.get(`/${serverConfig.msConfigureService}/version/detail/${guid}/`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.versionNo = res.data.data.versionNo;
          this.versionDesc = res.data.data.versionDesc;
          this.appSideGuid = res.data.data.appSideGuid;
          this.bizState = res.data.data.bizState;
          this.articleId = guid;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msConfigureService}/version/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msConfigureService}/version/del`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.versionNo) {
        self.$message('请输入版本号');
        return;
      }
      if (!this.versionDesc) {
        self.$message('请输入说明');
        return;
      }
      if (!this.appSideGuid) {
        self.$message('请选择应用端');
        return;
      }
      var req = {
        versionNo: this.versionNo,
        versionDesc: this.versionDesc,
        bizState: this.bizState,
        appSideGuid: this.appSideGuid,
      };

      self.api.postJson(`/${serverConfig.msConfigureService}/version/add`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('发布成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.versionNo) {
        self.$message('请输入版本号');
        return;
      }
      if (!this.versionDesc) {
        self.$message('请输入说明');
        return;
      }
      if (!this.appSideGuid) {
        self.$message('请选择应用端');
        return;
      }
      var req = {
        versionNo: this.versionNo,
        versionDesc: this.versionDesc,
        bizState: this.bizState,
        appSideGuid: this.appSideGuid,
        guid: this.articleId,
      };

      self.api.put(`/${serverConfig.msConfigureService}/version/update`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAppSideGuidList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.appSideGuidList = res.data.data.records;
        }
      });
    },
    getAppSideName(guid) {
      var appSideGuidList = this.appSideGuidList;
      var item = appSideGuidList.filter((item) => item.guid == guid);
      if (item.lenght == 0) return;
      return item[0].appSideName;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>